import React, { Fragment, useState } from 'react';
import PropTypes from 'prop-types';

import { connect } from 'react-redux';

// Actions

// Components - imported
import { Avatar } from '@material-ui/core';
import { format } from 'date-fns';

const VersusBlock = ({
    match_info,
}) => {
    
    return (
        <div style={{width: '100%', padding: '8px 16px', boxSizing: 'border-box'}}>
            <div key={match_info._id} style={{width: '100%', minHeight: '60px', display: 'flex', justifyContent: 'space-between', alignItems: 'center', background: 'rgba(247,249,249)', borderRadius: '12px', boxSizing: 'border-box', cursor: 'pointer', padding: '8px 12px', position: 'relative'}}>
                <div style={{display: 'flex', flexDirection: 'column', gap: '4px'}}>
                    {/* Team 1 */}
                    <div style={{height: '23px', gap: '8px', display: 'flex', alignItems: 'center'}}>
                        {/* Logo img */}
                        {match_info.logo_team_1 && (
                            <div style={{height: '23px', width: '30px', overflow: 'hidden', display: 'flex', alignItems: 'center', justifyContent: 'center'}}>
                                <img src={match_info.logo_team_1} style={{width: '100%'}} />
                            </div>
                        )}

                        {/* Team Name */}
                        <span style={{wordWrap: 'break-word', fontSize: '15px', fontWeight: 600}}>
                            {match_info.team_1_name}
                        </span>
                    </div>

                    {/* Team 2 */}
                    <div style={{height: '23px', gap: '8px', display: 'flex', alignItems: 'center'}}>
                        {/* Logo img */}
                        {match_info.logo_team_2 && (
                            <div style={{height: '23px', width: '30px', overflow: 'hidden', display: 'flex', alignItems: 'center', justifyContent: 'center'}}>
                                <img src={match_info.logo_team_2} style={{width: '100%'}} />
                            </div>
                        )}

                        {/* Team Name */}
                        <span style={{wordWrap: 'break-word', fontSize: '15px', fontWeight: 600}}>
                            {match_info.team_2_name}
                        </span>
                    </div>
                    
                </div>

                {/* Date */}
                {match_info?.start_date ? (
                    <div style={{height: '100%', display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', paddingRight: '10px', fontSize:'13px', color: 'rgb(83, 100, 113)'}}>
                        <p style={{fontWeight: 500, fontSize: '14px'}}>{format(match_info.start_date, "MMM d")}</p>
                        {!match_info?.start_time_tbd ? (
                            <p>{format(match_info.start_date, "h:mm a")}</p>
                        ) : (
                            <p>TBD</p>
                        )}
                    </div>
                ) : (
                    <div style={{height: '100%', display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', paddingRight: '10px', fontSize:'13px', color: 'rgb(83, 100, 113)'}}>
                        <p style={{fontWeight: 500, fontSize: '14px'}}>TBD</p>
                    </div>
                )}

                {/* Invisible overlay for catching mouse clicks around the 'Message' btn */}
                <div 
                    onClick={() => window.location.href = `/vs/${match_info._id}?show=posts`} 
                    style={{position: 'absolute', top: 0, bottom: 0, right: 0, left: 0, zIndex: 9}}
                ></div>
            </div>
        </div>
    )
}

const mapStateToProps = state => ({

})

export default connect(mapStateToProps, { 

    // Connecting actions from Redux to the component
})(VersusBlock);